export default __webpack_public_path__ + "bg_p_ptisabel.jpg";